export const correctLink = (link) => {
  if (link?.startsWith('http')) {
    return link;
  } else {
    return '//' + link;
  }
};

export default correctLink;
